export default __webpack_public_path__ + "static/media/payment.98fd6619.png";